import createCache from '@emotion/cache';
export const createEmbedEmotionCache = (options) => createCache(Object.assign({ key: 'fwn', speedy: false }, options));
